import React, { Component } from 'react';

import {
  Router,
  Switch,
  Route
} from "react-router-dom";

import PrivateRoute from './components/PrivateRoute';

import Login from './pages/Login';
import TwoFactorAuth from './pages/TwoFactorAuth';
import Error404 from './pages/Error404';
import Projects from './pages/Projects';
import history from "./utils/history";
import {ROUTES} from "./utils/constants";
import Products from './pages/Products';
import Error500 from './pages/Error500';
import FeatureUpdates from "./pages/FeatureUpdates";
import {scrollToObject} from './utils/helperUtils';
import ReactGA from 'react-ga';

history.listen((location) => {
  scrollToObject();
  if (window.hasOwnProperty("ga")) {
    ReactGA.pageview(location.pathname);
  }
});

export default class Routes extends Component {
  render() {
    return (
      <Router history={history}>
        <Switch >
          <Route exact path={ROUTES.AUTH} component={Login} />
          <Route exact path={ROUTES.TWO_FACTOR_AUTH} component={TwoFactorAuth} />
          <Route path={ROUTES.FOUR_OH_FOUR} component={Error404} />
          <Route path={ROUTES.FIVE_HUNDRED} component={Error500} />
          <Route path={ROUTES.FEATURE_UPDATES} component={FeatureUpdates} />
          <PrivateRoute path={ROUTES.PRODUCTS} component={Products} />
          <PrivateRoute path={ROUTES.PROJECTS} component={Projects} />
          <Route component={Error404} />
        </Switch>
      </Router>
    )
  }
};
